import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseAction } from "@/Common/Stores/Actions/BaseAction";

class RamqActions extends BaseAction {
    public GetFamilyDoctor(individualID: string): void {
        var requestData = {
            Patient: { IndividualID: individualID },
            CurrentUser: sessionStore.getCurrentEmployee().getRamqCredentials()
        };

        if (sessionStore.clientConfiguration.HasMedfarRAMQ || cacheStore.ClinicSettings.EnableRamqGL6Service) {
            this.Execute(ServerOperations.Server.RAMQ_CheckSubscription, requestData);
        }
    }
}

export { RamqActions };
